import { render, staticRenderFns } from "./SearchClientOrSupplier.vue?vue&type=template&id=97dc0ad0&scoped=true"
import script from "./SearchClientOrSupplier.vue?vue&type=script&lang=js"
export * from "./SearchClientOrSupplier.vue?vue&type=script&lang=js"
import style0 from "./SearchClientOrSupplier.vue?vue&type=style&index=0&id=97dc0ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dc0ad0",
  null
  
)

export default component.exports